<template>
    <content-loader
        :width="385"
        :height="498"
        :speed="2"
        primaryColor="#eeeeee"
        secondaryColor="#979797"
    >
        <rect width="385" height="220" x="0" y="0" />
        <rect width="82" height="16" x="5" y="225" rx="3" ry="3" />
        <rect width="151" height="16" x="5" y="245" rx="3" ry="3" />
        <rect width="227" height="16" x="78" y="277" rx="3" ry="3" />
        <rect width="188" height="85" x="0" y="306" />
        <rect width="188" height="85" x="196" y="306" />
        <rect width="179" height="18" x="10" y="415" rx="3" ry="3" />
        <rect width="93" height="12" x="52" y="440" rx="3" ry="3" />
        <rect width="145" height="18" x="213" y="402" rx="3" ry="3" />
        <rect width="38" height="18" x="266" y="427" rx="3" ry="3" />
        <rect width="170" height="12" x="200" y="450" rx="3" ry="3" />
        <rect width="385" height="22" x="0" y="476" />
    </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader"

export default {
    components: {
        ContentLoader
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/ContentLoaders/UsedVehicleResult.vue